'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  scrollable: _propTypes2.default.bool
};

var defaultProps = {
  scrollable: false
};

/** Prop Receivers */
var baseProps = function baseProps(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var zIndex = theme.reactackle.components.dialog.window.zIndex;


  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];

  return '\n    z-index: ' + (zIndex + 1) + ';\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
};

var visible = function visible(_ref2) {
  var visible = _ref2.visible;
  return 'display: ' + (visible ? 'flex' : 'none') + ';';
};

/** Styles */
var ModalStyled = exports.ModalStyled = _styledComponents2.default.div.withConfig({
  displayName: 'ModalStyled'
})(['position:fixed;width:100%;height:100vh;top:0;left:0;justify-content:space-between;align-items:center;display:flex;overflow:hidden;will-change:transform,opacity;', ';', ';', ';'], visible, baseProps, (0, _reactackleCore.transition)('opacity, transform'));

ModalStyled.propTypes = propTypes;
ModalStyled.defaultProps = defaultProps;
ModalStyled.displayName = 'ModalStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-dialog/dist/styles/ModalStyled.js
// module id = 666
// module chunks = 0